import { useEffect, useState } from "react";
import { Wand2, Layers, FolderPlus } from "lucide-react";
import { Link } from "react-router-dom";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import api from "@/lib/api";

/** اختيار مصدر المكتبة بوضوح: مشاريع التوليد الفردي (خدمات بلا اشتراك) أو المشاريع الاستراتيجية — ثم المشروع المطلوب. */
export const LibrarySourcePicker = ({ scope, setScope, sp, setSp, projects, activeProject, selectProject }) => {
  const [studio, setStudio] = useState([]);
  useEffect(() => { api.get("/me/studio-projects").then((r) => setStudio(r.data)).catch(() => {}); }, []);
  const Card = ({ id, Icon, title, desc, count }) => (
    <button type="button" onClick={() => setScope(id)} data-testid={`library-scope-${id}`}
      className={`flex-1 min-w-[220px] text-start rounded-2xl border p-3 transition-colors ${scope === id ? "border-primary bg-primary/10 ring-1 ring-primary/40" : "border-border bg-secondary/40 hover:border-primary/40"}`}>
      <div className="flex items-center gap-2 font-bold text-sm"><Icon className={`w-4 h-4 ${scope === id ? "text-primary" : "text-muted-foreground"}`} /> {title} <span className="text-xs font-normal text-muted-foreground">({count})</span></div>
      <p className="text-[11px] text-muted-foreground mt-1">{desc}</p>
    </button>
  );
  return (
    <div className="rounded-2xl border border-border p-3 space-y-3" data-testid="library-source">
      <p className="text-xs font-bold">١ · من أي مكان تريد عرض المحتوى؟</p>
      <div className="flex flex-wrap gap-2">
        <Card id="individual" Icon={Wand2} title="مشاريع التوليد الفردي" desc="خدمات حسب الطلب بلا اشتراك — كل مشروع باسم نشاطك يجمع ما ولّدته له" count={studio.length} />
        <Card id="project" Icon={Layers} title="المشاريع الاستراتيجية" desc="مشاريع الاستراتيجية والحملات من صفحة «المشاريع» — محتوى الحملات والمنشورات" count={projects.length} />
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <p className="text-xs font-bold">٢ · اختر المشروع:</p>
        {scope === "individual" ? (
          <Select value={sp || "all"} onValueChange={(v) => setSp(v === "all" ? "" : v)}>
            <SelectTrigger className="w-[260px] bg-secondary border-border h-9" data-testid="library-studio-select"><SelectValue placeholder="مشروع التوليد الفردي" /></SelectTrigger>
            <SelectContent className="bg-popover border-border">
              <SelectItem value="all" data-testid="library-studio-all">كل مشاريع التوليد الفردي</SelectItem>
              {studio.map((p) => <SelectItem key={p.id} value={p.id} data-testid={`library-studio-option-${p.id}`}>{p.name}</SelectItem>)}
            </SelectContent>
          </Select>
        ) : projects.length ? (
          <Select value={activeProject?.id || ""} onValueChange={selectProject}>
            <SelectTrigger className="w-[260px] bg-secondary border-border h-9" data-testid="library-project-select"><SelectValue placeholder="اختر المشروع الاستراتيجي" /></SelectTrigger>
            <SelectContent className="bg-popover border-border">
              {projects.map((p) => <SelectItem key={p.id} value={p.id} data-testid={`library-project-option-${p.id}`}>{p.name}</SelectItem>)}
            </SelectContent>
          </Select>
        ) : <span className="text-xs text-muted-foreground">لا توجد مشاريع استراتيجية بعد.</span>}
        <Link to={scope === "individual" ? "/app/studio?individual=1" : "/app/projects"} className="inline-flex items-center gap-1 text-xs text-primary underline underline-offset-2" data-testid="library-new-project-link">
          <FolderPlus className="w-3.5 h-3.5" /> {scope === "individual" ? "إنشاء مشروع توليد فردي جديد" : "إنشاء مشروع استراتيجي"}
        </Link>
      </div>
    </div>
  );
};
